import React, { useCallback } from 'react';
import classNames from 'classnames';
import { DataRoomNodeProps } from '../../types';
import { displayDataRoomNodeSize, getNodeMimeType } from 'utils';
import { Checkbox } from 'ncoded-component-library';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import { isMaximumSelected } from 'router/subrouters/DataRoom/utils';

import './DataRoomFile.styles.scss';

const DataRoomFile: React.FC<DataRoomNodeProps> = (props) => {
  const { className, node, disabledLabel, readOnly, onChange } = props;

  const { _id, document, name, checked, disabled, fileSecurity } = node || {};

  const classes = classNames(
    'data-room-file',
    { selected: checked, disabled },
    className,
  );

  const nodeSize = document?.size;

  const handleChange = useCallback(() => {
    if (disabled || readOnly) return;

    onChange(_id, !checked);
  }, [_id, disabled, readOnly, checked, onChange]);

  return (
    <div className={classes}>
      <Checkbox
        checked={checked}
        disabled={disabled || readOnly}
        onChange={handleChange}
        label={
          <div>
            <div className="name">
              <MymeTypeIcon
                mimeType={getNodeMimeType(node)}
                isLocked={isMaximumSelected(fileSecurity)}
              />
              <p>{name}</p>

              {disabled && !!disabledLabel && <p>{disabledLabel}</p>}
            </div>

            <p>{displayDataRoomNodeSize(nodeSize)}</p>
          </div>
        }
      />
    </div>
  );
};

export default DataRoomFile;
